import { useQuery } from "@apollo/client/react";
import { useMemo } from "react";

import { useCachedFilterFields } from "components/Filters/hooks";
import { SortOption } from "components/Filters/types";
import { PublicWorkerPool } from "types/generated";

import { SEARCH_PUBLIC_WORKER_POOL_USED_BY_SUGGESTIONS } from "./gql";

const useSearchPublicWorkerPoolUsedBySuggestions = () => {
  const { data } = useQuery<{
    publicWorkerPool: PublicWorkerPool;
  }>(SEARCH_PUBLIC_WORKER_POOL_USED_BY_SUGGESTIONS, {
    variables: {
      input: {
        fullTextSearch: null,
        predicates: null,
        fields: null,
      },
    },
  });

  const cachedFiltersData = useCachedFilterFields(
    data?.publicWorkerPool?.searchUsersSuggestions?.fields
  );

  const sortOptions = useMemo((): SortOption[] => {
    return cachedFiltersData
      .filter((field) => field.orderable)
      .map((field) => {
        return {
          value: field.name,
          label: field.name,
        };
      });
  }, [cachedFiltersData]);

  return {
    sortOptions,
  };
};

export default useSearchPublicWorkerPoolUsedBySuggestions;
